import Footer from "../components/Footer";
import StoryHeroList from "../components/StoryHeroList";
import StoryFeature from "../components/StoryFeature";
import IntroStoryBook from "../components/StoryIntro.js";
import StoryCta from "../components/StoryCta";
import StoryLibraryJourney from "../components/StoryLibraryJourney";
import Seo from "../components/Seo";
import { URLS } from "../utils/constants";

const StoryBook = () => {
  const meta = URLS.storyBook;

  return (
    <div className="about-page">
      <Seo title={meta.title} description={meta.desc} keywords={meta.keywords} image={meta.metaImage} path={meta.path} />
      <IntroStoryBook />

      <StoryHeroList />

      <StoryFeature />

      <StoryCta />

      <Footer />
    </div>
  );
};

export default StoryBook;
